import { StockOrderType } from '@toro/common/shared/models/stocks-exchange/stock-order.model';

export const STANDARD_LOT = 100;

const FRACTIONAL_SYMBOL_REGEX = /^([A-Z0-9]{4}\d{1,2})F$/i;

export const getBaseSymbol = (symbol: string): string => {
  const match = (symbol || '').match(FRACTIONAL_SYMBOL_REGEX);
  return match ? match[1] : symbol;
};

export const isFractionalOrder = (symbol: string, standardLot: number): boolean =>
  Number(standardLot) === 1 && FRACTIONAL_SYMBOL_REGEX.test(symbol || '');

export const splitOrderByLot = (order: StockOrderType, standardLot: number): StockOrderType[] => {
  const quantity = Number(order && order.orderQty);
  if (!order || !isFractionalOrder(order.symbol, standardLot) || !Number.isInteger(quantity) || quantity <= 0) {
    return [order];
  }

  const baseSymbol = getBaseSymbol(order.symbol);
  const standardQty = Math.floor(quantity / STANDARD_LOT) * STANDARD_LOT;
  const fractionalQty = quantity % STANDARD_LOT;
  const orders: StockOrderType[] = [];

  if (standardQty > 0) {
    orders.push({ ...order, symbol: baseSymbol, orderQty: standardQty } as StockOrderType);
  }
  if (fractionalQty > 0) {
    orders.push({ ...order, symbol: `${baseSymbol}F`, orderQty: fractionalQty } as StockOrderType);
  }

  return orders;
};
